<template>
  <li v-if="item.type === 'text'" class="list-item" v-html="item.data"></li>
  <li v-else class="list-item">{{item.data.data.name}} </li>
</template>

<script>
import { ContainerMixin, ElementMixin } from "vue-slicksort";

export default {
  name: 'SortableItem',
  mixins: [ElementMixin],
  props: ["item"],
}
</script>

<style>
  li {display: table-row}
</style>

